import script from "./form.vue?vue&type=script&setup=true&lang=ts"
export * from "./form.vue?vue&type=script&setup=true&lang=ts"

import "./form.vue?vue&type=style&index=0&id=7c5ca27b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c5ca27b"]])

export default __exports__